module.exports = __webpack_public_path__ + "static/media/destroyed-planet.2ccea36d.svg";